import * as React from 'react';
import {ImageField, ReferenceField, Show, SimpleShowLayout, TextField, useShowContext} from 'react-admin';


const ContactPersonShowLayout = () => {
    const {
        error,
        isLoading,
        record,
    } = useShowContext();

    if (isLoading) {
        return <div>Loading...</div>;
    }
    if (error) {
        return <div>Error!</div>;
    }
    return (
        <SimpleShowLayout>
            <TextField source="id" label={"ID"}/>
            {record.profilePicture !== null && <ImageField source={"profilePicture"} label={"Profil kép"}/>}
            <TextField source="name" label={"Név"}/>
            <TextField source="email" label={"Email"}/>
            <TextField source="phone" label={"Telefonszám"}/>
            <ReferenceField source="employerId"
                            reference="employer"
                            link="show"
                            label={"Projekt"}>
                <TextField source="name"/>
            </ReferenceField>
            <TextField source="position" label={"Pozíció"}/>
            <TextField source="facebookLink" label={"Facebook link"}/>
        </SimpleShowLayout>
    );
};


export const ContactPersonShow = () => {
    return <Show title={'Kapcsolattartó'}>
        <ContactPersonShowLayout/>
    </Show>;
};
